/* cart-upsell.js — NO DRAG; header with title + nav wrapper; sale price strike-through + TOGGLE */
(function () {
  'use strict';

  // ---- Config / selectors ---------------------------------------------------
  var ROOT_SEL = '#CartUpsell';
  var GRID_SEL = '[data-upsell-grid]';
  var SCROLLER_SEL = '.cart-upsell__scroller';
  var HEADER_CLASS = 'cart-upsell__header';
  var TITLE_CLASS  = 'cart-upsell__title';
  var NAV_WRAP_CLASS = 'cart-upsell__nav';
  var BTN_PREV_CLASS = 'cart-upsell__prev';
  var BTN_NEXT_CLASS = 'cart-upsell__next';
  var HAS_NAV_CLASS  = 'cart-upsell--has-nav';
  var TOGGLE_BTN_CLASS = 'cart-upsell__toggle';
  var COLLAPSED_CLASS  = 'cart-upsell--collapsed';
  var LEFT_WRAP_CLASS  = 'cart-upsell__left';

  // ---- DOM helpers ----------------------------------------------------------
  function $(sel, root){ return (root || document).querySelector(sel); }
  function create(tag, cls){ var el = document.createElement(tag); if (cls) el.className = cls; return el; }
  function px(n){ return typeof n === 'number' ? n : 0; }
  function uid(prefix){ return (prefix || 'id') + '-' + Math.random().toString(36).slice(2,9); }

  // ---- Money ---------------------------------------------------------------
  function formatUSD(cents) {
    var n = (cents || 0) / 100;
    try { return '$' + n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
    catch(e){ return '$' + n.toFixed(2); }
  }

  // ---- Data: cart + product recommendations --------------------------------
  function getCart(){
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function(r){ return r.json(); });
  }
  function getRecommendations(productId, limit){
    var url = '/recommendations/products.json?product_id=' + productId + '&limit=' + (limit || 8) + '&intent=related';
    return fetch(url, { credentials: 'same-origin' })
      .then(function(r){ return r.json(); })
      .then(function(d){ return (d && d.products) ? d.products : []; });
  }
  function filterProducts(products, cart){
    var inCart = new Set((cart.items || []).map(function(i){ return i.product_id; }));
    return products.filter(function(p){
      var isGiftType = /gift ?card/i.test(p.product_type || '');
      var isGiftTag  = (p.tags || []).some(function(t){ return /gift ?card/i.test(t); });
      return !inCart.has(p.id) && !isGiftType && !isGiftTag;
    });
  }

  // ---- Card rendering (with sale strike-through) ---------------------------
  function renderCard(p){
    var card = create('div', 'cart-upsell-card');

    var href = p.url || ('/products/' + p.handle);

    var aImg = create('a');
    aImg.href = href;
    aImg.setAttribute('aria-label', p.title || 'View product');

    var imgEl = create('img', 'cart-upsell-card__img');
    var imgObj = (p.images && p.images[0]) || p.featured_image || {};
    var src = (typeof imgObj === 'string') ? imgObj : (imgObj.src || '');
    if (src) src += (src.indexOf('?') === -1 ? '?width=360' : '');
    imgEl.src = src || 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';
    imgEl.alt = p.title || '';
    imgEl.draggable = false;
    imgEl.style.webkitUserDrag = 'none';
    imgEl.style.userSelect = 'none';
    aImg.appendChild(imgEl);
    card.appendChild(aImg);

    var aTitle = create('a', 'cart-upsell-card__title');
    aTitle.href = href;
    aTitle.textContent = p.title || 'Product';
    aTitle.style.userSelect = 'none';
    card.appendChild(aTitle);

    // --- Price (supports sale + ranges with compare_at) ---
    var priceWrap = create('div', 'cart-upsell-card__price');

    var minVar = (p.variants && p.variants.length)
      ? p.variants.reduce(function(best, v){ return (!best || v.price < best.price) ? v : best; }, null)
      : null;

    var priceMin = (p.price_min != null) ? p.price_min : (minVar && minVar.price) || 0;
    var priceMax = (p.price_max != null) ? p.price_max : priceMin;
    var hasRange = priceMax > priceMin;

    var wasForMin = (minVar && minVar.compare_at_price) || p.compare_at_price_min || p.compare_at_price_max || 0;
    var isOnSaleAtMin = wasForMin > priceMin;

    if (hasRange) {
      if (isOnSaleAtMin) {
        priceWrap.innerHTML =
          '<s class="price-was">' + formatUSD(wasForMin) + '</s>' +
          '<span class="price-now">From ' + formatUSD(priceMin) + '</span> ';
      } else {
        priceWrap.textContent = 'From ' + formatUSD(priceMin);
      }
    } else {
      if (isOnSaleAtMin) {
        priceWrap.innerHTML =
          '<s class="price-was">' + formatUSD(wasForMin) + '</s>' +
          '<span class="price-now">' + formatUSD(priceMin) + '</span> ';
      } else {
        priceWrap.textContent = formatUSD(priceMin);
      }
    }
    card.appendChild(priceWrap);

    var cta = create('a', 'cart-upsell-card__btn');
    cta.href = href;
    cta.textContent = 'View product';
    cta.style.userSelect = 'none';
    card.appendChild(cta);

    return card;
  }

  // ---- Header (left: toggle+title, right: nav) ------------------------------
  function ensureHeaderWithNav(root){
    var title = root.querySelector('[data-upsell-title]') ||
                root.querySelector('.' + TITLE_CLASS) ||
                root.querySelector('h2, h3');

    var header = root.querySelector('.' + HEADER_CLASS);
    if (!header) {
      header = create('div', HEADER_CLASS);
      header.style.display = 'flex';
      header.style.alignItems = 'center';
      header.style.justifyContent = 'space-between';
      root.insertBefore(header, root.firstChild);
    }

    // Left wrap holds [toggle + title]
    var leftWrap = header.querySelector('.' + LEFT_WRAP_CLASS);
    if (!leftWrap) {
      leftWrap = create('div', LEFT_WRAP_CLASS);
      leftWrap.style.display = 'inline-flex';
      leftWrap.style.alignItems = 'center';
      leftWrap.style.gap = '0.5rem';
      header.insertBefore(leftWrap, header.firstChild);
    }

    // Ensure we have a title element and it sits inside leftWrap
    if (!title) {
      title = create('h3', TITLE_CLASS);
      title.textContent = root.dataset.title || 'You may also like';
    } else {
      title.classList.add(TITLE_CLASS);
    }
    if (title.parentNode !== leftWrap) {
      leftWrap.appendChild(title);
    }

    // Right side nav wrap (prev/next)
    var navWrap = root.querySelector('.' + NAV_WRAP_CLASS);
    if (!navWrap) {
      navWrap = create('div', NAV_WRAP_CLASS);
      header.appendChild(navWrap); // at far right via space-between
    }

    return { header: header, title: title, navWrap: navWrap, leftWrap: leftWrap };
  }

  // ---- Toggle (open/close scroller) ----------------------------------------
  function setupToggle(root, scroller){
    if (root.__toggleReady) return;
    root.__toggleReady = true;

    var parts  = ensureHeaderWithNav(root);
    var title  = parts.title;
    var left   = parts.leftWrap;

    var btn = create('button', TOGGLE_BTN_CLASS);
    btn.type = 'button';
    btn.setAttribute('aria-label', 'Show or hide recommendations');

    if (!scroller.id) scroller.id = uid('upsell-scroller');
    btn.setAttribute('aria-controls', scroller.id);

    // Put the button BEFORE the title but inside the left group
    left.insertBefore(btn, title);

    // Icon-only button (chevron down)
    btn.innerHTML = (
      '<svg aria-hidden="true" focusable="false" role="presentation" ' +
      'class="icon icon--wide icon-chevron-down" viewBox="0 0 28 16">' +
      '<path d="m1.57 1.59 12.76 12.77L27.1 1.59" stroke-width="2" stroke="#000" fill="none"></path>' +
      '</svg>'
    );

    function setState(collapsed){
      var icon = btn.querySelector('svg');
      if (collapsed) {
        root.classList.add(COLLAPSED_CLASS);
        btn.setAttribute('aria-expanded', 'false');
        scroller.style.display = 'none';
        if (icon) icon.style.transform = 'rotate(180deg)';
      } else {
        root.classList.remove(COLLAPSED_CLASS);
        btn.setAttribute('aria-expanded', 'true');
        scroller.style.display = '';
        if (icon) icon.style.transform = 'rotate(0deg)';
      }
    }

    // Initial state
    setState(root.classList.contains(COLLAPSED_CLASS));

    btn.addEventListener('click', function(){
      var willCollapse = btn.getAttribute('aria-expanded') === 'true';
      setState(willCollapse);
    });
  }

  // ---- Resolve the correct scroller ----------------------------------------
  function resolveScroller(root, grid) {
    // Prefer the closest ancestor with the scroller class
    var byClosest = grid.closest(SCROLLER_SEL);
    if (byClosest) return byClosest;

    // Otherwise, find a scroller within root
    var byQuery = $(SCROLLER_SEL, root);

    // If we found a scroller but it doesn't wrap the grid, move the grid inside it
    if (byQuery && !byQuery.contains(grid)) {
      byQuery.appendChild(grid);
      return byQuery;
    }

    // Fall back to the grid itself acting as the scroller
    return grid;
  }

  // ---- Nav (prev/next + snapping) ------------------------------------------
  function setupNav(root, scroller) {
    if (root.__navReady) return;
    root.__navReady = true;

    var parts = ensureHeaderWithNav(root);
    var navWrap = parts.navWrap;

    // Scroller snapping behavior
    scroller.style.scrollSnapType = 'x mandatory';
    scroller.style.scrollBehavior = 'smooth';

    // Apply snap to cards (not wrapper)
    var cards = scroller.querySelectorAll('.cart-upsell-card');
    cards.forEach(function(el){
      el.style.scrollSnapAlign = 'start';
      el.style.scrollSnapStop = 'always';
    });

    var btnPrev = create('button', BTN_PREV_CLASS);
    btnPrev.type = 'button';
    btnPrev.setAttribute('aria-label', 'Previous products');
    btnPrev.innerHTML = '<span aria-hidden="true"><svg class="icon icon-arrow-chevron" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path></svg></span>';

    var btnNext = create('button', BTN_NEXT_CLASS);
    btnNext.type = 'button';
    btnNext.setAttribute('aria-label', 'Next products');
    btnNext.innerHTML = '<span aria-hidden="true"><svg class="icon icon-arrow-chevron" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path></svg></span>';

    navWrap.appendChild(btnPrev);
    navWrap.appendChild(btnNext);
    root.classList.add(HAS_NAV_CLASS);

    [btnPrev, btnNext].forEach(function(btn){
      btn.addEventListener('pointerdown', function(e){ e.stopPropagation(); }, { passive: true });
      btn.style.pointerEvents = 'auto';
      btn.style.zIndex = '10';
    });

    function getCardStep() {
      var firstCard = scroller.querySelector('.cart-upsell-card');
      if (!firstCard) return scroller.clientWidth * 0.9;
      var cs = window.getComputedStyle(firstCard);
      var cardW = firstCard.offsetWidth + px(parseFloat(cs.marginLeft)) + px(parseFloat(cs.marginRight));
      if (!cardW) return scroller.clientWidth * 0.9;
      var perView = Math.max(1, Math.floor(scroller.clientWidth / cardW));
      return cardW * perView; // group-like step
    }
    function maxScroll() { return Math.max(0, scroller.scrollWidth - scroller.clientWidth); }
    function clamp(val, min, max){ return Math.min(max, Math.max(min, val)); }

    function snapToNearest() {
      var items = scroller.querySelectorAll('.cart-upsell-card');
      if (!items.length) return;
      var target = scroller.scrollLeft;
      var bestEl = null, bestDist = Infinity;
      items.forEach(function(el){
        var left = el.offsetLeft;
        var dist = Math.abs(left - target);
        if (dist < bestDist) { bestDist = dist; bestEl = el; }
      });
      if (bestEl) bestEl.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
    }

    btnPrev.addEventListener('click', function(){
      var step = getCardStep();
      var nextLeft = clamp(scroller.scrollLeft - step, 0, maxScroll());
      scroller.scrollTo({ left: nextLeft, behavior: 'smooth' });
    });
    btnNext.addEventListener('click', function(){
      var step = getCardStep();
      var nextLeft = clamp(scroller.scrollLeft + step, 0, maxScroll());
      scroller.scrollTo({ left: nextLeft, behavior: 'smooth' });
    });

    root.addEventListener('keydown', function(e){
      if (e.key === 'ArrowLeft') { e.preventDefault(); btnPrev.click(); }
      if (e.key === 'ArrowRight'){ e.preventDefault(); btnNext.click(); }
    });

    var snapTimeout = 0;
    scroller.addEventListener('scroll', function(){
      clearTimeout(snapTimeout);
      snapTimeout = setTimeout(snapToNearest, 120);
    }, { passive: true });
  }

  // ---- Render list and init -------------------------------------------------
  function renderList(root, products){
    var grid = $(GRID_SEL, root);
    if (!grid) return;

    grid.innerHTML = '';
    products.forEach(function(p){ grid.appendChild(renderCard(p)); });
    root.style.display = products.length ? '' : 'none';

    // Find/resolve the actual scroller element (wrapper or grid)
    var scroller = resolveScroller(root, grid);

    // Scroller: owns the overflow + a11y
    scroller.style.overflowX = 'auto';
    scroller.style.overflowY = 'hidden';
    scroller.style.webkitOverflowScrolling = 'touch';
    scroller.setAttribute('role', 'region');
    scroller.setAttribute('aria-label', 'Recommended products');
    scroller.style.position = scroller.style.position || 'relative';
    scroller.style.zIndex = scroller.style.zIndex || '1';

    // Grid: owns the layout of cards
    grid.style.display = 'grid';
    grid.style.gridAutoFlow = 'column';
    grid.style.gridAutoColumns = 'max-content';
    grid.style.columnGap = grid.style.columnGap || '12px';

    // Ensure grid is inside the scroller (resolveScroller may have moved it)
    if (!scroller.contains(grid)) scroller.appendChild(grid);

    // Init UI bits (pass the resolved scroller!)
    setupToggle(root, scroller);
    setupNav(root, scroller);
  }

  function init(){
    var root = $(ROOT_SEL);
    if (!root) return;

    if (getComputedStyle(root).position === 'static') root.style.position = 'relative';

    var limit = parseInt(root.dataset.limit || '6', 10);

    function refresh(){
      getCart().then(function(cart){
        if (!cart || !cart.items || !cart.items.length) {
          root.style.display = 'none';
          return;
        }
        var pid = cart.items[0].product_id;
        return getRecommendations(pid, limit + cart.items.length).then(function(recs){
          var filtered = filterProducts(recs, cart).slice(0, limit);
          renderList(root, filtered);
        });
      }).catch(function(){ root.style.display = 'none'; });
    }

    refresh();
    document.addEventListener('cart:open', refresh);
    document.addEventListener('ajaxProduct:added', refresh);
    document.addEventListener('cart:updated', refresh);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
